// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logo_wrapper__7ucLf"};